class HeroBanner extends HTMLElement {
  constructor() {
    super();
    this.heroBannerSlides = document.querySelectorAll('#hero-banner-slider .keen-slider__slide');
    this.slideContentInner = this.querySelectorAll('.slide__content-inner');
    if (this.heroBannerSlides.length > 1) this.createSlider();
    else this.noSlider();
  }

  createSlider() {
    var slider = new KeenSlider("#hero-banner-slider", {loop: true,}, 
    [
      navigation,
      (slider) => {
        let timeout
        let mouseOver = false
        function clearNextTimeout() {
          clearTimeout(timeout)
        }
        function nextTimeout() {
          clearTimeout(timeout)
          if (mouseOver) return
          timeout = setTimeout(() => {
            slider.next()
          }, 5000)
        }
        slider.on("created", () => {
          slider.container.addEventListener("mouseover", () => {
            mouseOver = true
            clearNextTimeout()
          })
          slider.container.addEventListener("mouseout", () => {
            mouseOver = false
            nextTimeout()
          })
          nextTimeout()
        })
        slider.on("dragStarted", clearNextTimeout)
        slider.on("animationEnded", nextTimeout)
        slider.on("updated", nextTimeout)
      },
    ])
  }

  noSlider() {
    this.slideContentInner.forEach(el => el.classList.add('no-slider'));
  }
}

customElements.define('hero-banner', HeroBanner);